var React = require('react');

function Editor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":" M 980.875 641.167 L 980.875 665 L 1006.875 665 L 1006.875 641.167 L 980.875 641.167 Z  M 983.042 643.333 L 1004.708 643.333 L 1004.708 645.5 L 983.042 645.5 L 983.042 643.333 Z  M 983.042 647.667 L 1004.708 647.667 L 1004.708 662.833 L 983.042 662.833 L 983.042 647.667 Z  M 993.875 649.833 L 991.708 660.667 L 993.875 660.667 L 996.042 649.833 L 993.875 649.833 Z  M 988.661 650.273 L 985.411 654.607 L 984.938 655.25 L 985.412 655.893 L 988.662 660.227 L 990.421 658.94 L 987.646 655.25 L 990.422 651.56 L 988.661 650.273 Z  M 999.089 650.273 L 997.329 651.56 L 1000.104 655.25 L 997.328 658.94 L 999.088 660.227 L 1002.338 655.893 L 1002.813 655.25 L 1002.338 654.607 L 999.089 650.273 Z "}));
}

Editor.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"980.875 641.167 26 23.833","width":"26","height":"23.833"};

module.exports = Editor;

Editor.default = Editor;
